import { render, staticRenderFns } from "./mainEditDialog.vue?vue&type=template&id=51c4eef8&scoped=true&"
import script from "./mainEditDialog.vue?vue&type=script&lang=js&"
export * from "./mainEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./mainEditDialog.vue?vue&type=style&index=0&id=51c4eef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c4eef8",
  null
  
)

export default component.exports